module.exports = __webpack_public_path__ + "static/media/car-battery.e750ca91.svg";